import { Card } from '../api/responses/payment-portal-login';
import { Details } from './user.models';
import { toInt } from 'src/app/shared/utilities/number.utils';

export const getPrimary = (item: Card | Details): boolean => toInt(item.index) === 1;
export const getByIndex =
	(index: number) =>
	(item: Card | Details): boolean =>
		toInt(item.index) === index;
